import { render, staticRenderFns } from "./Ultimos.vue?vue&type=template&id=8d291600&"
import script from "./Ultimos.vue?vue&type=script&lang=js&"
export * from "./Ultimos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports